import { Stack } from "@mui/material";

function KsbToolbarUser({ children, sx = {} }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={{
        minWidth: "max-content",
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
}

export default KsbToolbarUser;
